import * as actionTypes from '../Actions/actionTypes';

// Application State
const initialState = {
    isConnected:false,
    session:null,
    isLogged:false,
    clientList:[],
    clientActive:"",
    menuList:[],
    logginError: false,
    username:"",
    fiduciaireName:"",
    fullScopeData:[],
    activeData:[],
    formatedData:[],
}

const getFullScope = (state, action) =>{
  
    return state;
}


const formatingData = (state, action)=>{

    var formatedData = [];

    // state.clientList
    // state.menuList
    // state.fullScopeData
    console.log("FORMATING");
    var dataTMP = [];
    state.clientList.forEach(client => {
        dataTMP = action.data.data.filter(item=>item.LINK_DB === client.LINK_DB);
        
        var pie0labels = dataTMP.filter(item=>item.ARCS_REQ ===23).map(item=>{return item.K02});
        var pie0Data = dataTMP.filter(item=>item.ARCS_REQ ===23).map(item=>{return  Math.abs(item.V01)});

        var pie1labels = dataTMP.filter(item=>item.ARCS_REQ ===24).map(item=>{return item.K02});
        var pie1Data = dataTMP.filter(item=>item.ARCS_REQ ===24).map(item=>{return  Math.abs(item.V01)});
        
        var totalCA = dataTMP.filter(item=>item.ARCS_REQ ===19).map(item=>{return item.V01<0?0:item.V01}).reduce((a, b) => a + b, 0);
        var other = dataTMP.filter(item=>item.ARCS_REQ ===19).filter(item=>item.V01<(totalCA/100)*5).map(item=>{return item.V01<0?0:Number.parseFloat(Number.parseFloat(item.V01).toFixed(2))}).reduce((a, b) => a + b, 0);
        var pie2labels = dataTMP.filter(item=>item.ARCS_REQ ===19).sort((a, b) =>{
            if (a.V01 > b.V01 )
               return -1;
            if (a.V01 < b.V01 )
               return 1;
            // a doit être égal à b
            return 0;
          }).filter(item=>item.V01>(totalCA/100)*5).map(item=>{return item.K01});
        var pie2Data = dataTMP.filter(item=>item.ARCS_REQ ===19).sort((a, b) =>{
            if (a.V01 > b.V01 )
               return -1;
            if (a.V01 < b.V01 )
               return 1;
            // a doit être égal à b
            return 0;
          }).filter(item=>item.V01>(totalCA/100)*5).map(item=>{return item.V01<0?0:Number.parseFloat(Number.parseFloat(item.V01).toFixed(2))});
        if(other>0){
            pie2labels.push("OTHER");
            pie2Data.push(Number.parseFloat(Number.parseFloat(other).toFixed(2)));
        }


        var barChartValue = dataTMP.filter(item=>item.ARCS_REQ ===6);
        var barChart2 = [
            {
                name:'Achat',
                data:barChartValue.map(item=>{return item.V04}).concat(barChartValue.map(item=>{return item.V05})),
            },
            {
                name:'Vente',
                data:barChartValue.map(item=>{return item.V01}).concat(barChartValue.map(item=>{return item.V03})),
            }];
            var barChartLabels2 = barChartValue.map(item=>{return item.K02}).concat(barChartValue.map(item=>{return item.K02}));
 


        var formatedClient = {
            id : client.K01,
            name : client.K02,
            dbLink : client.LINK_DB,
            requetes : [],
            dashboard : [
                {
                    graphtype:"bar",
                    name : "Valeurs Financières",
                    data :dataTMP.filter(item=>item.ARCS_REQ ===30).map(item=>{return ({x:item.K03,y:Number.parseFloat(item.V01).toFixed(2)})}),
                    category : "Solde(s)",
                },
                
                {
                    graphtype:"pie",
                    name : "Chiffre d'affaires par type de comptes généraux (Exercice en cours)",
                    data :pie0Data,
                    labels: pie0labels,
                },
                {
                    graphtype:"pie",
                    name : "Chiffre d'affaires par type de comptes généraux (Exercice antérieur)",
                    data :pie1Data,
                    labels: pie1labels,
                },
                {
                    graphtype:"pie",
                    name : "Chiffre d'affaires par pays",
                    data :pie2Data,
                    labels: pie2labels,
                },
                {
                    graphtype:"bar",
                    name : "Marges brutes par année (60=>70)",
                },
                {
                    graphtype:"bar",
                    name : "Achats / Ventes",
                    data :barChart2,
                    xaxis :barChartLabels2,
                    category : "Solde(s)",
                },
            ],
        };
        
        // GET ALL REQUEST
        action.data.requetes.filter(item=>item.NUMERO !==25).forEach(requete => {
            var formatedRequete = {
                number: requete.NUMERO,
                name : requete.TITRE.split(" - ")[1],
                category : requete.TITRE.split(" - ")[0],
                columns : [],
                data : [],

            }
            // FORMAT COLUMNS
            // K = text
            var typeTmp ="text";
            var AmountTesteur = ["Solde","Montant","HTVA","H.T.V.A","T.T.C","Exercic","Securité sociale","Rémunérations","Différence"];
            var dataReqTmp = dataTMP.filter(item=>item.ARCS_REQ ===requete.NUMERO);
            
            if(requete.K01_TITRE.length>0){
                typeTmp ="text";
                var k01 = dataReqTmp.map(item=>{return {value:item.K01,rowNumber:item.ARCS}});
                if(k01.length>0){
                    // GET DATA 
                    // DETECT TYPE
                    if(RegExp(/\d{2}\/\d{2}\/\d{4}/g).test(k01[0].value)){typeTmp = "date"}
                    if(requete.K01_TITRE==="Devise(s)"){typeTmp = "devise"}
                    var k01MaxLength = Math.max(...k01.map(el => el.value.length));
                    if(k01MaxLength>20){typeTmp = "large"}
                }
               
                formatedRequete.columns.push({
                    name:requete.K01_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"K01",
                    size:typeTmp==="large"?2:1,
                    data:k01,
                });
            }
            if(requete.K02_TITRE.length>0){
                
                typeTmp ="text";
                var k02 = dataReqTmp.map(item=>{return {value:item.K02,rowNumber:item.ARCS}});
                if(k02.length>0){
                    // GET DATA 
                    // DETECT TYPE
                    if(RegExp(/\d{2}\/\d{2}\/\d{4}/g).test(k02[0].value)){typeTmp = "date"}
                    if(requete.K02_TITRE==="Devise(s)"){typeTmp = "devise"}
                    var k02MaxLength = Math.max(...k02.map(el => el.value.length));
                    if(k02MaxLength>20){ typeTmp = "large"}
                }

                formatedRequete.columns.push({
                    name:requete.K02_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"K02",
                    size:typeTmp==="large"?2:1,
                    data:k02,
                });
            }
            if(requete.K03_TITRE.length>0){
                typeTmp ="text";
                var k03 = dataReqTmp.map(item=>{return {value:item.K03,rowNumber:item.ARCS}});
                if(k03.length>0){
                    // GET DATA 
                    // DETECT TYPE
                    if(RegExp(/\d{2}\/\d{2}\/\d{4}/g).test(k03[0].value)){typeTmp = "date"}
                    if(requete.K03_TITRE==="Devise(s)"){typeTmp = "devise"}
                    var k03MaxLength = Math.max(...k03.map(el => el.value.length));
                    if(k03MaxLength>20){ typeTmp = "large"}
                }

                formatedRequete.columns.push({
                    name:requete.K03_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"K03",
                    size:typeTmp==="large"?2:1,
                    data:k03,
                });
            }
            if(requete.K04_TITRE.length>0){
                typeTmp ="text";
                var k04 = dataReqTmp.map(item=>{return {value:item.K04,rowNumber:item.ARCS}});
                if(k04.length>0){
                // GET DATA 
                // DETECT TYPE
                if(RegExp(/\d{2}\/\d{2}\/\d{4}/g).test(k04[0].value)){typeTmp = "date"}
                if(requete.K04_TITRE==="Devise(s)"){typeTmp = "devise"}
                var k04MaxLength = Math.max(...k04.map(el => el.value.length));
                if(k04MaxLength>20){ typeTmp = "large"}
                }

                formatedRequete.columns.push({
                    name:requete.K04_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"K04",
                    size:typeTmp==="large"?2:1,
                    data:k04,
                });
            }
            if(requete.K05_TITRE.length>0){
                typeTmp ="text";
                var k05 = dataReqTmp.map(item=>{return {value:item.K05,rowNumber:item.ARCS}});
                if(k05.length>0){
                // GET DATA 
                // DETECT TYPE
                if(RegExp(/\d{2}\/\d{2}\/\d{4}/g).test(k05[0].value)){typeTmp = "date"}
                if(requete.K05_TITRE==="Devise(s)"){typeTmp = "devise"}
                var k05MaxLength = Math.max(...k05.map(el => el.value.length));
                if(k05MaxLength>20){ typeTmp = "large"}
                }

                formatedRequete.columns.push({
                    name:requete.K05_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"K05",
                    size:typeTmp==="large"?2:1,
                    data:k05,
                });
            }

            if(requete.V01_TITRE.length>0){
                typeTmp ="number";
                var v01 = dataReqTmp.map(item=>{return {value:item.V01,rowNumber:item.ARCS}});
                if(v01.length>0){
                    if(RegExp(/\d+\.\d{1}/g).test(v01[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V01_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V01_TITRE.includes("%")){typeTmp = "percent"};

                }
                formatedRequete.columns.push({
                    name:requete.V01_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V01",
                    size:1,
                    data:v01,
                });

            }
            if(requete.V02_TITRE.length>0){
                typeTmp ="number";
                var v02 = dataReqTmp.map(item=>{return {value:item.V02,rowNumber:item.ARCS}});
                if(v02.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v02[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V02_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V02_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V02_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V02",
                    size:1,
                    data:v02,
                });
            }
            if(requete.V03_TITRE.length>0){
                typeTmp ="number";
                var v03 = dataReqTmp.map(item=>{return {value:item.V03,rowNumber:item.ARCS}});
                if(v03.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v03[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V03_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V03_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V03_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V03",
                    size:1,
                    data:v03,
                });
            }
            if(requete.V04_TITRE.length>0){
                typeTmp ="number";
                var v04 = dataReqTmp.map(item=>{return {value:item.V04,rowNumber:item.ARCS}});
                if(v04.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v04[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V04_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V04_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V04_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V04",
                    size:1,
                    data:v04,
                });
            }
            if(requete.V05_TITRE.length>0){
                typeTmp ="number";
                var v05 = dataReqTmp.map(item=>{return {value:item.V05,rowNumber:item.ARCS}});
                if(v05.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v05[0].value)){typeTmp = "amount"}
                    AmountTesteur.forEach(function(word){
                        if(requete.V05_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V05_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V05_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V05",
                    size:1,
                    data:v05,
                });
            }
            if(requete.V06_TITRE.length>0){
                typeTmp ="number";
                var v06 = dataReqTmp.map(item=>{return {value:item.V06,rowNumber:item.ARCS}});
                if(v06.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v06[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V06_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V06_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V06_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V06",
                    size:1,
                    data:v06,
                });
            }
            if(requete.V07_TITRE.length>0){
                typeTmp ="number";
                var v07 = dataReqTmp.map(item=>{return {value:item.V07,rowNumber:item.ARCS}});
                if(v07.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v07[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V07_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V07_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V07_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V07",
                    size:1,
                    data:v07,
                });
            }
            if(requete.V08_TITRE.length>0){
                typeTmp ="number";
                var v08 = dataReqTmp.map(item=>{return {value:item.V08,rowNumber:item.ARCS}});
                if(v08.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v08[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V08_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V08_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V08_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V08",
                    size:1,
                    data:v08,
                });
            }
            if(requete.V09_TITRE.length>0){
                typeTmp ="number";
                var v09 = dataReqTmp.map(item=>{return {value:item.V09,rowNumber:item.ARCS}});
                if(v09.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d+/g).test(v09[0].value)){typeTmp = "amount"};
                    AmountTesteur.forEach(function(word){
                        if(requete.V09_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V09_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V09_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V09",
                    size:1,
                    data:v09,
                });
            }
            if(requete.V10_TITRE.length>0){
                typeTmp ="number";
                var v10 = dataReqTmp.map(item=>{return {value:item.V10,rowNumber:item.ARCS}});
                if(v10.length>0){// DETECT TYPE
                    if(RegExp(/\d+\.\d{2}/g).test(v10[0].value)){typeTmp = "amount"}
                    AmountTesteur.forEach(function(word){
                        if(requete.V10_TITRE.includes(word)){typeTmp = "amount"};
                    });
                    if(requete.V10_TITRE.includes("%")){typeTmp = "percent"};
                }
                formatedRequete.columns.push({
                    name:requete.V10_TITRE,
                    type:typeTmp,
                    sort:"",
                    id:"V10",
                    size:1,
                    data:v10,
                });
            }
            var dataTmp = [];
            var numberOfRow = formatedRequete.columns[0].data.length;
            var listOfValue = [];
            for (let i = 0; i < numberOfRow; i++) {
                listOfValue = [];
                formatedRequete.columns.forEach(column => {
                    listOfValue.push(column.data[i]);
                });
                dataTmp.push(listOfValue);
            }
            formatedRequete.data = dataTmp;

            formatedClient.requetes.push(formatedRequete);
        });
        
        
        formatedData.push(formatedClient);
    });

    console.log("Formated Data",formatedData);

    state.formatedData = formatedData;
    state.clientActive = formatedData[0].dbLink;

    return {...state};

}

const openSessionReturns = (state, action)=>{
    
    if(action.data.response.data ===true){
        state.isConnected = true;
        state.session = action.data.sessionReact;
    }else{
        state.isConnected = false;
    }

    return state;
}

const someStateUpdater = (state, action)=>{
    return { ...state}
}

const loginReturns = (state, action)=>{
    state.isLogged = action.data;
    state.logginError = !action.data;
    
    return { ...state}
}
const onLogout = (state, action)=>{
    state.isLogged = action.data;
    state.fiduciaireName = null;
    state.isConnected = false;
    state.session=null;
    state.isLogged=false;
    state.clientList=[];
    state.menuList=[];
    state.logginError= false;
    state.username="";
    state.fiduciaireName="";
    state.fullScopeData=[];
    state.activeData=[];


    return { ...state}
}

const onExtractUsername = (state, action)=>{
    state.username = action.data;
    
    return { ...state}
}
const onExtractFiduciaire = (state, action)=>{
    state.username = action.data;
    
    return { ...state}
}

const getClientListing = (state, action)=>{
    state.clientList = action.data;
    
    //console.log(state.clientList);
    return { ...state}
}


const createMenu = (state, action)=>{
    state.menuList = action.data.map((dataItem, i)=>{
        var columns = [];


        return {
            key:i,
            NUMERO:dataItem.NUMERO,
            ITEM:dataItem.TITRE.split(" - ")[0],
            SUBITEM:dataItem.TITRE.split(" - ")[1],
            DATA:[],
            COLUMN:columns,
        }
    });
    state.menuList.sort(( a, b )=> {
        if ( a.SUBITEM < b.SUBITEM){
            return -1;
          }
          if ( a.SUBITEM > b.SUBITEM ){
            return 1;
          }
          return 0;
      });
    state.menuList.sort(( a, b )=> {
        if ( a.ITEM < b.ITEM){
            return -1;
          }
          if ( a.ITEM > b.ITEM ){
            return 1;
          }
          return 0;
      });
      state.menuList = state.menuList.filter(item=>item.SUBITEM !== undefined);
    return { ...state}
}

const updateActiveDATAResult = (state, action)=>{
    var activeDataTemp = state.menuList.filter(item=>item.ITEM===action.data.item && item.SUBITEM===action.data.subitem);
    console.log(activeDataTemp);
    state.activeData = activeDataTemp.length>0?activeDataTemp[0].DATA:null;
    
    return { ...state}
}

const updateClientActive = (state, action)=>{
    state.clientActive = action.data
    return { ...state}
}

const sortHeader = (state,action) =>{
    var column = action.data.column;
    var menu = action.data.item;
    var subitem = action.data.subitem;


    var columnsArray =  state.menuList.filter(item=>item.ITEM===menu && item.SUBITEM===subitem)[0].COLUMN;
    var data = state.menuList.filter(item=>item.ITEM===menu && item.SUBITEM===subitem)[0].DATA;
    columnsArray.forEach((columnItem,i) => {
      if(columnItem.name === column.name){
        columnItem.sort ==="up"? columnItem.sort = "down" :columnItem.sort = "up";
        // CREATE SORTING SCRIPT

        data = data.sort(( a, b )=> {
          if(columnItem.sort === "up"){
            if(isNaN(parseInt(a[i].name, 10)) || isNaN(parseInt(b[i].name, 10))){
                return a[i].name.localeCompare(b[i].name);
            }else{
                return parseInt(a[i].name, 10) - parseInt(b[i].name, 10);
            }


            // if ( (isNaN(parseInt(a[i].name, 10))? a[i].name: parseInt(a[i].name, 10))> (isNaN(parseInt(b[i].name, 10))? b[i].name: parseInt(b[i].name, 10)) ){
            //   return -1;
            // }
            // if ( (isNaN(parseInt(a[i].name, 10))? a[i].name: parseInt(a[i].name, 10)) < (isNaN(parseInt(b[i].name, 10))? b[i].name: parseInt(b[i].name, 10)) ){
            //   return 1;
            // }
            // return 0;
          }else{
            if(isNaN(parseInt(a[i].name, 10)) || isNaN(parseInt(b[i].name, 10))){
                return b[i].name.localeCompare(a[i].name);
            }else{
                return parseInt(b[i].name, 10) - parseInt(a[i].name, 10);
            }


            // if ( (isNaN(parseInt(a[i].name, 10))? a[i].name: parseInt(a[i].name, 10)) < (isNaN(parseInt(b[i].name, 10))? b[i].name: parseInt(b[i].name, 10)) ){
            //   return -1;
            // }
            // if ( (isNaN(parseInt(a[i].name, 10))? a[i].name: parseInt(a[i].name, 10)) > (isNaN(parseInt(b[i].name, 10))? b[i].name: parseInt(b[i].name, 10)) ){
            //   return 1;
            // }
            // return 0;
          }

          
        });

      }else{
        columnItem.sort = null;
      }
    });
    state.activeData = data;
    //this.setState({columns:columnsArray, data:data});
    //this.props.menuList.filter(item=>item.ITEM===this.props.activeMenu && item.SUBITEM===this.props.activeSubMenu)[0].COLUMN = columnsArray;
    return { ...state}
  }

const sortHeaderByColumnId = (state,action) =>{
    var columnId = action.data.columnId;
    var dbLink = action.data.dbLink;
    var menu = action.data.menu;
    var subitem = action.data.subitem;

    var data = state.formatedData.filter(item=>item.dbLink === dbLink)[0].requetes.filter(item=>item.name === subitem && item.category === menu)[0];
    var sortedData = [];
    data.columns.forEach((column,i) => {
      if(i === columnId){
        var dataTmp = [...data.data];
       
        if(column.sort === "up"){
            column.sort = "down";
            sortedData = dataTmp.sort(( a, b )=> {
                
                if(isNaN(parseInt(a[i].value, 10)) || isNaN(parseInt(b[i].value, 10))){
                    return a[i].value.localeCompare(b[i].value);
                }else{
                    return parseInt(a[i].value, 10) - parseInt(b[i].value, 10);
                }

            });
        }else{
            column.sort = "up";
            sortedData = dataTmp.sort(( a, b )=> {
                
                if(isNaN(parseInt(a[i].value, 10)) || isNaN(parseInt(b[i].value, 10))){
                    return b[i].value.localeCompare(a[i].value);
                }else{
                    return parseInt(b[i].value, 10) - parseInt(a[i].value, 10);
                }
        });

        }
      }else{
        column.sort = "";
      }
    });
    data.data = sortedData;


    state.activeData = data;
    return { ...state}
  }


const apiReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SOME_ACTION:
            return someStateUpdater(state,action);
        case actionTypes.LOGIN_RETURN:
            return loginReturns(state,action);
        case actionTypes.LOGOUT:
            return onLogout(state,action);
        case actionTypes.OPEN_SESSION_RETURN:
            return openSessionReturns(state,action);
        case actionTypes.EXTRACT_USERNAME:
            return onExtractUsername(state,action);
        case actionTypes.EXTRACT_FIDUCIAIRE:
            return onExtractFiduciaire(state,action);
        case actionTypes.CLIENT_LISTING:
            return getClientListing(state,action);
        case actionTypes.CREATE_MENU:
            return createMenu(state,action);
        case actionTypes.GET_FULL_SCOPE:
            return getFullScope(state,action);
        case actionTypes.SORT_HEADER:
            return sortHeader(state,action);
        case actionTypes.SORT_HEADER_BY_COLUMN_ID:
            return sortHeaderByColumnId(state,action);
        case actionTypes.UPDATE_ACTIVE_DATA:
            return updateActiveDATAResult(state,action);
        case actionTypes.UPDATE_CLIENT_ACTIVE:
            return updateClientActive(state,action);
        case actionTypes.ON_FORMATING_DATA:
            return formatingData(state,action);
        default:
            return someStateUpdater(state,action);
    }
}



export default apiReducer;

    /*
    {
        User : "Pascal Vanspouwen",
        Entity : "Fiduciaire Name"
        Clients :[{
            name : "XXXX",
            dbLink : "0200",
            requetes : [
                {
                number : 24,
                name :"XXXXXXXX XXXXXXX",
                category : "XXXXX",
                columns : [
                    {
                        id : 0,
                        name : "",
                        type : "",
                        syze : 1,
                    },
                    {
                        id : 1,
                        name : "",
                        type : "",
                        syze : 1,
                    },
                ],
                data : [
                    ["XXXX1",1200],
                    ["XXXX2",1201],
                    ["XXXX3",1202],
                    ["XXXX4",1203],
                    ["XXXX5",1204],
                ]
            }
            ]
        },
        ]
    }
*/
/*
    dashboard: [
        {
            type : "pie",
            name : "XXXXXX XXXXX",
            data : {
                label:["XXX1","XXX2"],
                value:[0001,0002]
            },
        },
        {
            type : "bar",
            name : "XXXXXX XXXXX",
            data : {
                value:[
                    {x:"XXX1",y:"100"},
                    {x:"XXX2",y:"200"},
                ],
                xName :"",
                yName :"",
            },
        }
    ]
    */